import { appendSpecificitySelector } from './increaseSpecificity';
const parseStyle = (element, seed) => {
    if (element.parent?.return) {
        element.parent.return = appendSpecificitySelector(element.parent.return, seed);
    }
    if (element?.props) {
        if (Array.isArray(element?.props)) {
            element.props = element.props.map(elProp => appendSpecificitySelector(elProp, seed));
        }
        else if (element.props.length) {
            element.props = appendSpecificitySelector(element.props, seed);
        }
    }
    if (element.return) {
        element.return = appendSpecificitySelector(element.return, seed);
    }
    if (element.value) {
        element.value = appendSpecificitySelector(element.value, seed);
    }
    return element;
};
const createStylisCustomPlugin = (seed) => {
    const stylisCustomPlugin = (element, _index, children, _callback) => {
        element = parseStyle(element, seed);
        children = children.map(childElem => parseStyle(childElem, seed));
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _callback = stylisCustomPlugin;
    };
    return stylisCustomPlugin;
};
export default createStylisCustomPlugin;
//# sourceMappingURL=stylisCustomSpecificityPlugin.js.map